module.exports = __webpack_public_path__ + "assets/images/sizeofOffice-01.8e3c321b5be57e5474a5e20badb75575.svg";